export default "__VITE_ASSET__BCbQv94F__"